import { render, staticRenderFns } from "./deviceMaterialDetail.vue?vue&type=template&id=cf733a12&scoped=true&"
import script from "./deviceMaterialDetail.vue?vue&type=script&lang=js&"
export * from "./deviceMaterialDetail.vue?vue&type=script&lang=js&"
import style0 from "./deviceMaterialDetail.vue?vue&type=style&index=0&id=cf733a12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf733a12",
  null
  
)

export default component.exports